module.exports = __webpack_public_path__ + "img/topup-wallet.f6cb1671.svg";